import { render } from "./aliyun.vue?vue&type=template&id=6dec43c1"
import script from "./aliyun.vue?vue&type=script&lang=js"
export * from "./aliyun.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__